<template>
  <div class="Jkxkz">
    <JKXKZ />
  </div>
</template>
<script>
import JKXKZ from "@/components/JKXKZ.vue";
export default {
  components: { JKXKZ },
  data() {
    return {};
  },

  methods: {},
};
</script>
<style lang="scss" scoped>
.Jkxkz {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  background-color: #efefef;
  overflow-y: scroll;
}
</style>